import React, { Fragment, forwardRef, useState } from 'react'
import classNames from 'classnames'

import Handle from './Handle'
import { useTranslation } from 'react-i18next'

import styles from '../../../styles/Container.module.css'
import { Box, IconButton, TextField, Typography } from '@mui/material'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded'
import { middlePanelStyles } from '../../../styles/classes/FormBuilderClasses'

const Container = forwardRef(
  (
    {
      children,
      columns = 1,
      handleProps,
      horizontal,
      hover,
      onClick,
      onRemove,
      label,
      placeholder,
      style,
      scrollable,
      shadow,
      unstyled,
      activeSections,
      sectionIndex,
      onShowHideSection,
      questions,
      onEditSectionName,
      pageIndex,
      isDraggingAny,
      ...props
    },
    ref
  ) => {
    const Component = onClick ? 'button' : 'div'
    const [disabledEdit, setDisabledEdit] = useState(true)
    const { classes } = middlePanelStyles()
    const { t } = useTranslation()

    let elementLabel = t('form_builder.element')
    if (questions?.length > 1) elementLabel = t('form_builder.element_plural')

    return (
      <Component
        {...props}
        ref={ref}
        style={{
          ...style,
          '--columns': columns
        }}
        className={classNames(
          styles.Container,
          unstyled && styles.unstyled,
          horizontal && styles.horizontal,
          hover && styles.hover,
          placeholder && styles.placeholder,
          scrollable && styles.scrollable,
          shadow && styles.shadow
        )}
        onClick={onClick}
        tabIndex={onClick ? 0 : undefined}
      >
        <Box className={classes.sectionSelector}>
          <Box className={classes.iconContainer}>
            <IconButton
              onClick={() => onShowHideSection(sectionIndex)}
              color="inherit"
              disableRipple
              className={classes.arrow}
            >
              {activeSections[sectionIndex] && <ArrowDropDownRoundedIcon />}
              {!activeSections[sectionIndex] && <ArrowRightRoundedIcon />}
            </IconButton>
            <TextField
              onDoubleClick={() => {
                setDisabledEdit(false)
              }}
              onBlur={() => setDisabledEdit(true)}
              disabled={disabledEdit}
              inputProps={{
                className: classes.sectionTitle
              }}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                className: classes.elementSectionTitle
              }}
              placeholder={t('form_builder.section_title')}
              onChange={event =>
                onEditSectionName(event.target.value, sectionIndex)
              }
              defaultValue={label}
              value={label}
            />
          </Box>
          <Handle {...handleProps} />
          <Box className={classes.elementCounterContainer}>
            <Typography className={classes.dataCounterText}>
              {questions?.length > 0
                ? `${questions?.length} ${elementLabel}`
                : t('form_builder.no_elements')}
            </Typography>
          </Box>
        </Box>
        <Box className={`${classes.droppableContainer} ${isDraggingAny && classes.droppableContainerActive}`}>
          {activeSections[sectionIndex] && <Fragment>{children}</Fragment>}
        </Box>
      </Component>
    )
  }
)

Container.displayName = 'Container'

export default Container
